import { createSelector } from 'reselect'
import _ from 'lodash'
import { populateLogs } from './Logs'

export const getAllReports = (state) => state.data['body-map-reports']

export const getBodyMapLogs = createSelector([populateLogs], (logs) => {
  return _.filter(logs, 'bodyMapReport')
})

export const getAllBodyMapReports = createSelector(
  [getAllReports, getBodyMapLogs],
  (reports, logs) => {
    if (!reports || !logs) return null
    const logsByReportId = _.groupBy(logs, 'bodyMapReport')
    return reports.map((report) => ({
      ...report,
      logs: logsByReportId[report.id] || null,
    }))
  }
)

const getResidentId = (state, { resident }) => resident
export const getResidentBodyMapReports = createSelector(
  [getAllBodyMapReports, getResidentId],
  (reports, resident) => {
    if (!reports || !resident) return null
    return _.filter(reports, { resident })
  }
)

const getId = (state, { id }) => id
// find body map report by ID
export const getResidentBodyMapReport = createSelector(
  [getAllBodyMapReports, getId],
  (reports, id) => {
    if (!reports || !id) return null
    return _.find(reports, { id })
  }
)
